var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width:'100%', height:'100%', 'background-repeat':'no-repeat', 'background-position':'50% 50%', 'background-size':'contain', backgroundImage:`url(${_vm.bgImg})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }